import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Router } from '@angular/router';

export const RedirectToRootMasterArticleGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const router = inject(Router);

  const articleSeoUrl = route.params.seoUrl;

  // eslint-disable-next-line local-rules/no-navigate-in-guard
  return router.navigate([`what-is/${articleSeoUrl}`], {
    skipLocationChange: true,
  });
};
